import { Alert, Button, Stack } from '@mui/material';
import { DialogSurface, ResourceState } from '../../../design-system';
import type { BulkOperationDetail, BulkOperationReceipt } from '../model/bulkOperations';
import { bulkDateLabel, bulkOperationLabel } from '../model/presentation';
import { BulkOperationResults, BulkStatus } from './BulkOperationResults';

export type BulkOperationResultDialogProps = {
  job?: BulkOperationDetail;
  loading: boolean;
  error?: string;
  submitError?: string;
  busy?: boolean;
  receipt?: BulkOperationReceipt;
  onClose: () => void;
  onRefresh: () => void;
  onCorrect?: () => void;
  onSubmit?: () => void | Promise<void>;
  onOpenStaffingChange?: (id: string) => void;
};

export function BulkOperationResultDialog({ job, loading, error, submitError, busy = false, receipt, onClose, onRefresh, onCorrect, onSubmit, onOpenStaffingChange }: BulkOperationResultDialogProps) {
  const title = !job ? '처리 현황' : job.operationType === 'STAFFING_CHANGE'
    ? `${job.totalRows.toLocaleString()}명 일괄 발령`
    : `${bulkOperationLabel(job.operationType)} 처리 현황`;
  const description = job ? [receipt?.effectiveDate ? `시행일 ${receipt.effectiveDate}` : undefined, `요청 ${bulkDateLabel(job.createdAt)}`].filter(Boolean).join(' · ') : undefined;
  const canSubmit = onSubmit && job?.status === 'VALIDATED' && job.totalRows > 0 && job.validRows === job.totalRows && job.failedRows === 0;
  return <DialogSurface
    open
    onClose={onClose}
    title={title}
    titleAdornment={job ? <BulkStatus value={job.status} /> : undefined}
    description={description}
    closeLabel="처리 현황 닫기"
    busy={busy}
    size="large"
    mobilePresentation="fullscreen"
    actions={<>
      <Button size="small" disabled={busy || loading} onClick={onRefresh} sx={{ mr: 'auto' }}>새로고침</Button>
      <Button variant="outlined" disabled={busy} onClick={onClose}>닫기</Button>
      {canSubmit && <Button variant="fill" disabled={busy || loading || error !== undefined} onClick={() => void onSubmit()}>검증된 행 적용</Button>}
    </>}
  >
    <ResourceState loading={loading && !job} loadingLabel="처리 현황을 불러오는 중입니다." loadingRows={3} error={job ? undefined : error} empty={!job} onRetry={onRefresh} retryLabel="다시 조회" embedded density="compact">
      <Stack spacing={2}>
        {job && error && <Alert severity="error" action={<Button size="small" onClick={onRefresh}>다시 조회</Button>}>{error}</Alert>}
        {submitError && <Alert severity="error">{submitError}</Alert>}
        {job && <BulkOperationResults job={job} compact receipt={receipt} busy={busy} onCorrect={onCorrect} onOpenStaffingChange={onOpenStaffingChange} />}
      </Stack>
    </ResourceState>
  </DialogSurface>;
}
